import { render, staticRenderFns } from "./CostSummary.vue?vue&type=template&id=24fc0d87&scoped=true"
import script from "./CostSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./CostSummary.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc0d87",
  null
  
)

export default component.exports